export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/round.js
// module id = 1026
// module chunks = 0